import { AbstractProductDataCommand } from "./abstractProductDataCommand";
import { VisualObjectOptions } from "../arguments/visualObjectOptions";

export class TabCommand extends AbstractProductDataCommand {

  visualObject: VisualObjectOptions;

  productIds?: Array<number>;
}